import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import ServicesPage from "@/pages/Services";

export const Route = createFileRoute("/$lang/services/")({
  head: ({ params }) => pageHead(params.lang, "services"),
  component: ServicesPage,
});
